angular.module("SupportAgent")
.controller(
 'TabAppsController',
 function ($scope, $rootScope, EventHandler, INTERACT,L) {
  $scope.installApp = function () {
   if(!$rootScope.isDiagTestReady($rootScope.conversationID)) return;
   var acid = $rootScope.getAccountID($rootScope.conversationID);
   var account = INTERACT.get_account(acid);
   //var url = "https://play.google.com/store/apps/details?id=example.matharithmetics";
   if ($scope.install_app) {
    EventHandler.APILAYER.sendMessage({
     convid: +account.dcid,
     channelid: INTERACT.D.xaction.channel.diagreq,
     msg: $rootScope.testPayload.installApp + $scope.install_app,
     devid: +account.d[account.sd].id
    });
    $rootScope.appendMessageToHistory({
     convid: $rootScope.conversationID, acid: $rootScope.accountID,
     display_name: "",
     msg: $rootScope.strings.str_diagnostic_request+$rootScope.getString('installApp'),
     msgtime: new Date(),
     channelid: 3, // TODO: magic
     convstatus: 1 // TODO: magic
    });
   }
   L.trace({app:$scope.install_app},"just tracing the content of install_app");
  };
  $scope.unInstallApp = function (appName) {
   if(!$rootScope.isDiagTestReady($rootScope.conversationID)) return;
   var acid = $rootScope.getAccountID($rootScope.conversationID);
   var account = INTERACT.get_account(acid);
   if (appName) {
    EventHandler.APILAYER.sendMessage({
     convid: +account.dcid,
     channelid: INTERACT.D.xaction.channel.diagreq,
     msg: $rootScope.testPayload.uninstallApp + appName,
     devid: +account.d[account.sd].id
    });
    $rootScope.appendMessageToHistory({
     convid: $rootScope.conversationID, acid: $rootScope.accountID,
     display_name: "",
     msg: $rootScope.strings.str_diagnostic_request+$rootScope.getString('uninstallApp'),
     msgtime: new Date(),
     channelid: 3, // TODO: magic
     convstatus: 1 // TODO: magic
    });
   }
  };
 });
